import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { zPaymentGateway, zPaymentStatus, zPaymentType } from '../enums';
import { zPrice } from '../primitives';

export const paymentSchema = z.object({
  amount: z.number(),
  eftposSurchargeAmount: z.number().nullable().default(null).optional(), // New field. Make required soon
  cashChange: z.number().nullable().default(null),
  cashGiven: z.number().nullable().default(null),
  /** @deprecated TODO: Remove later */
  fatZebraRawResponse: z.string().nullable().optional(),
  /** @deprecated TODO: Remove later */
  fatZebraTransactionId: z.string().nullable().optional(),
  last4: z.string().nullable().default(null),
  /** TODO: Bring behaviour into alignment with order.localCreatedAt? */
  localCreatedAt: z.number().default(() => Date.now()),
  /** TODO: Bring behaviour into alignment with order.localUpdatedAt? or remove? */
  localUpdatedAt: z.number().default(() => Date.now()),
  /** @deprecated TODO: Remove later */
  orderItemUuid: z.string().nullable().optional(),
  orderItemUuids: z.array(z.string()).nullable().default(null),
  paymentGateway: zPaymentGateway.nullable().default(null),
  paymentGatewayAccountId: z.string().nullable().default(null),
  /**
   * For STRIPE, `paymentGatewayPaymentId` maps to `paymentIntentId` value
   *
   * For LINKLY, `paymentGatewayPaymentId` maps to `linklySession.uuid`.
   * Linkly refunds need `Response.PurchaseAnalysisData.RFN` from the Linkly "transaction" response.
   * (Ideally we could store the RFN value in the `linklySessions` table?)
   * See https://www.linkly.com.au/apidoc/REST/#reference-number
   **/
  paymentGatewayPaymentId: z.string().nullable().default(null),
  paymentGatewayPaymentMethodId: z.string().nullable().default(null),
  paymentMethodId: z.string().nullable().default(null),
  paymentType: zPaymentType,
  /** The `uuid` of the iPad that took this payment — the Linkly `posId` used to resolve its device. */
  posTerminalUuid: z.string().nullable().default(null),
  posUserUuid: z.string().nullable().default(null),
  /** @deprecated TODO: Remove later. Create a separate `payment` record for refunds instead. */
  refundedAt: z.number().nullable().optional(),
  settledAt: z.number().nullable().default(null),
  status: zPaymentStatus.default('PAID'),
  /** Stripe may update payment `status` and `last4` after submission.
   * E.g. Payment `status` can change from `"AUTHORIZED"` => `"PAID"` or `"REFUNDED"` **/
  updatedAt: z.number().nullable().default(null),
  uuid: z.string().default(() => uuidv4()),
  /** @deprecated TODO: Remove later */
  voidedAt: z.number().nullable().optional(),
  /** @deprecated TODO: Remove later */
  xeroBankTransactionId: z.string().nullable().optional(),
});
export type Payment = z.output<typeof paymentSchema>;

/** Strict schema */
export const paymentStrictSchema = paymentSchema.safeExtend({
  amount: zPrice,
  eftposSurchargeAmount: zPrice.nullable().optional(),
  cashChange: zPrice.nullable(),
  cashGiven: zPrice.nullable(),
  orderItemUuid: z.guid().nullable().optional(),
  orderItemUuids: z.array(z.guid()).nullable(),
  posTerminalUuid: z.guid().nullable(),
  posUserUuid: z.guid().nullable(),
  uuid: z.guid(),
});
